export default "__VITE_ASSET__BYXFC7Hj__"